import { graphql } from "gql";

const INTERNAL_ADMIN_EDIT_TAG_CATEGORY_MUTATION = graphql(`
  mutation InternalAdminEditTagCategory(
    $organizationId: ID!
    $id: ID!
    $input: AdminEditTagCategoryInput!
  ) {
    internalAdminEditTagCategory(
      organizationId: $organizationId
      id: $id
      input: $input
    ) {
      ...InternalAdminTagCategory
    }
  }
`);

export default INTERNAL_ADMIN_EDIT_TAG_CATEGORY_MUTATION;
